import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

type Props = {
  open: boolean
  onOpenChange(open: boolean): void
  title?: string
  children: ReactNode
}

export const ImagePreviewDialog = ({ open, onOpenChange, title, children }: Props) => {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="ultrawide" className="bg-layer-1 p-3">
        <DialogTitle className="sr-only">{title ?? t('imagePreviewDialog.title')}</DialogTitle>
        <div className="flex items-center justify-center">{children}</div>
      </DialogContent>
    </Dialog>
  )
}
